module.exports = __webpack_public_path__ + "img/ch08_10_星星笔记本.e234fce9.jpg";